import { call, put, select, takeEvery } from "redux-saga/effects";
import { setAttr, setFormAttr, triggerAtualizaDadosBuffer, triggerAtualizarDados, triggerFirstLoad, triggerSendRPCCall } from "./RPCSlice";
import axios from "axios";
import { generalErrorAction, publicarError } from "../helper/general-error/GeneralErrorSlice";
import { formatDateComHoras, formatDateComHorasSomente, formatDateJavaComHoras, formatDateSemHoras, formataTamahoDeBytes, formataTimeDeMilli, isNotNull } from "../helper/functions";

function* doAtualizaDados() {

    // yield call(() => console.log("ok"))

    yield put(setAttr({
        campo: "silentLoading",
        valor: true
    }))

    yield call(() => callAtualizaDados())


    yield put(setAttr({
        campo: "silentLoading",
        valor: false
    }))
}

function* doAtualizaDadosBuffer() {

    // yield call(() => console.log("ok"))

    yield put(setAttr({
        campo: "silentLoading",
        valor: true
    }))

    yield call(() => callDadosBuffer())


    yield put(setAttr({
        campo: "silentLoading",
        valor: false
    }))
}

function* doSendRPCCall() {

    yield put(setFormAttr({
        campo: "error",
        valor: ""
    }))

    yield put(setFormAttr({
        campo: "response",
        valor: null
    }))

    var servidorUrl = yield select((state) => state.rpc.servidorUrl)
    var form = yield select((state) => state.rpc.form)

    if (form.action == null || form.action.trim().length < 3)
        yield put(setFormAttr({
            campo: "error",
            valor: "Action inválida"
        }))
    else {

        // yield call(() => console.log(form))

        // comeca
        yield put(setAttr({
            campo: "silentLoading",
            valor: true
        }))

        var token = yield select((state) => state.auth.token)
        var formData = new FormData()

        var formToSend = {
            action: form.action,
            runNow: form.runNow,
            payload: form.payload,
        }

        var arquivo = typeof (form.file) != "undefined" && form.file != null && form.file != false ? form.file : null;
        formData.append("file", arquivo)
        formData.append("data",
            new Blob([JSON.stringify(formToSend)], {
                type: "application/json"
            }))

        var r = yield call(() => axios.post(servidorUrl + "/rpc", formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + token
            },
            responseType: "arraybuffer", // Importante para baixar binario
        }).then(response => response)
            .catch(error => error))

        var downloadFile = (content, fileName, fileType) => {

            // Create a Blob from the variable content
            var blob = new Blob([content], { type: fileType });

            // console.log(blob)
            // console.log(blob.lemgtj)
            // Create a Blob URL
            var blobUrl = URL.createObjectURL(blob);

            // Create an anchor element
            var a = document.createElement('a');

            // Set the anchor's href attribute to the Blob URL
            a.href = blobUrl;

            // Set the download attribute to the desired file name
            a.download = fileName;

            // Programmatically click the anchor element to trigger the download
            document.body.appendChild(a);
            a.click();

            // Remove the anchor element
            document.body.removeChild(a);

            // Revoke the Blob URL to free up resources
            URL.revokeObjectURL(blobUrl);
        }


        // yield call(() => console.log(r))

        if (r.status && (r.status === 200 || r.status === 201)) {
            if (r.headers["content-type"] === "application/octet-stream") {
                // console.log(r)
                var d = r.data
                console.log(d)
                // if(typeof(d) == "object") {
                //     const textEncoder = new TextEncoder()
                //     d = textEncoder.encode(JSON.stringify(d))
                //     // console.log(d)
                //     // console.log(typeof(d))
                // } else {
                //     // var arrayBuffer = new Uint8Array(d)
                //     // console.log(d.length)
                //     // console.log(arrayBuffer.length)
                //     // arrayBuffer = arrayBuffer.buffer
                //     // console.log(arrayBuffer)
                //     // downloadFile([arrayBuffer], "file", r.headers["content-type"])
                // }
                downloadFile(d, "file", r.headers["content-type"])
                // downloadFile(d, "file", r.headers["content-type"])

                yield put(setFormAttr({
                    campo: "response",
                    valor: "Arquivo retorno esta sendo baixado"
                }))
            } else {
                let decoder = new TextDecoder('utf-8');
                let decodedString = decoder.decode(r.data);
                let json = JSON.parse(decodedString)
                console.log(json)
                yield put(setFormAttr({
                    campo: "response",
                    valor: json
                }))
            }
        } else {
            yield put(publicarError(generalErrorAction(
                "RpcSaga.doSendRPCCall",
                isNotNull(r.code) ? r.code : "",
                isNotNull(r.response) ? r.response.status : "",
                isNotNull(r.message) ? r.message : "",
                r
            )))
        }

        yield call(() => callAtualizaDados())

        yield put(setAttr({
            campo: "silentLoading",
            valor: false
        }))
        // termina



    }
}

function* callAtualizaDados() {
    var token = yield select((state) => state.auth.token)
    var servidorUrl = yield select((state) => state.rpc.servidorUrl)

    var r = yield call(() => axios.get(servidorUrl + "/rpc",
        {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(response => response)
        .catch(error => error))

    if (r.code == "ERR_NETWORK") {

        yield put(publicarError(generalErrorAction(
            "RPCSage.doFirstLoad",
            isNotNull(r.code) ? r.code : "",
            isNotNull(r.response) ? r.response.status : "",
            isNotNull(r.message) ? r.message : "",
            r
        )))
        return
    }

    // yield put(r.data)


    var data = []

    var oldestRecordDate = null
    var latestRecordDate = null

    yield put(setAttr({
        campo: "calls",
        valor: r.data
    }))

    var formattedCalls = [
        ...r.data.map(c => {
            return {
                ...c,
                formatted: {
                    receivedDate: formatDateJavaComHoras(c.receivedDate),
                    jsonLength: formataTamahoDeBytes(c.jsonLength),
                    fileLength: formataTamahoDeBytes(c.fileLength),
                    executionTime: formataTimeDeMilli(c.executionTime)
                }
            }
        })
    ]

    yield put(setAttr({
        campo: "callsFormatted",
        valor: formattedCalls
    }))


    r.data.forEach(d => {
        var receivedDate = new Date(d.receivedDate)

        if (oldestRecordDate == null || receivedDate < oldestRecordDate)
            oldestRecordDate = receivedDate

        if (latestRecordDate == null || receivedDate > latestRecordDate)
            latestRecordDate = receivedDate

        data.push({
            "action": d.action,
            "executionTime": d.executionTime,
            "error": d.error,
            "fileLength": d.fileLength,
            "jsonLength": d.jsonLength,
            "id": d.id,
            "externalId": d.externalId,
            "runNow": d.runNow,
            "success": d.success,
            "receivedDateRaw": receivedDate,
            "receivedDate": formatDateSemHoras(receivedDate)
        })
    })

    var Difference_In_Time = latestRecordDate.getTime() - oldestRecordDate.getTime();

    var diffInDays = Difference_In_Time / (1000 * 3600 * 24)
    var diffInHours = Difference_In_Time / (1000 * 3600)

    var resultados = {}

    var novoResultado = (data, requests, time, errors) => {
        return { data, requests, time, errors }
    }

    for (var i = 0; i < Math.floor(diffInDays); i++) {
        var dt = new Date(oldestRecordDate.getTime())
        dt = dt.setDate(oldestRecordDate.getDate() + i + 1)
        dt = new Date(dt)
        resultados[formatDateSemHoras(dt)]
            = novoResultado(dt, 0, 0, 0)
    }

    data.forEach(d => {

        var r = novoResultado(d.receivedDateRaw, 1, d.executionTime, d.success ? 0 : 1)

        if (typeof (resultados[d.receivedDate]) == "undefined") {
            resultados[d.receivedDate] = r
        } else {
            resultados[d.receivedDate].requests += r.requests
            resultados[d.receivedDate].time += r.time
            resultados[d.receivedDate].errors += r.errors
        }

    })

    var rs = []


    Object.keys(resultados).forEach(k => {

        var p = resultados[k]
        p.data = k
        rs.push(p)
    })

    rs.sort((a, b) => a.data > b.data ? 1 : -1)

    yield put(setAttr({
        campo: "resultados",
        valor: rs
    }))

    yield put(setAttr({
        campo: "resultadosPreparados",
        valor: {
            "datas": [...rs.map(r => r.data)],
            "requests": [...rs.map(r => r.requests)],
            "errors": [...rs.map(r => r.errors)],
            "time": [...rs.map(r => r.time)]
        }
    }))
}


function* callDadosBuffer() {
    var token = yield select((state) => state.auth.token)
    var servidorUrl = yield select((state) => state.rpc.servidorUrl)
    const formData = new FormData();
    const formToSend = {
        action: "RPC_RETORNA_DADOS_BUFFER_RPC",
        runNow: true,
        payload: JSON.stringify({})
    }

    formData.append("file", null);
    formData.append(
        "data",
        new Blob([JSON.stringify(formToSend)], {
            type: "application/json",
        })
    );

    var r = yield call(() => axios.post(servidorUrl + "/rpc", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": `Bearer ${token}`,
        }
    }).then(response => response)
        .catch(error => error))

    if (r.code == "ERR_NETWORK") {

        yield put(publicarError(generalErrorAction(
            "RPCSage.doFirstLoad",
            isNotNull(r.code) ? r.code : "",
            isNotNull(r.response) ? r.response.status : "",
            isNotNull(r.message) ? r.message : "",
            
        )))
        return
    }


    console.log("Data")
    console.log(r.data)

    
    yield put(setAttr({
        campo: "buffer",
        valor: {
            callsParaIniciar : r.data.payload["callsParaIniciar"],
            callsParaConcluir : r.data.payload["callsParaConcluir"],
        }
    }))
}

function* doFirstLoad() {

    // yield call(() => console.log("First Load"))

    yield put(setAttr({
        campo: "loading",
        valor: true
    }))

    yield call(() => callAtualizaDados())
    yield call(() => callDadosBuffer())

    yield put(setAttr({
        campo: "loading",
        valor: false
    }))


}

export function* listenFirstLoad() {
    yield takeEvery(triggerFirstLoad, doFirstLoad)
}

export function* listenAtualizarDados() {
    yield takeEvery(triggerAtualizarDados, doAtualizaDados)
}
export function* listenAtualizarDadosBuffer() {
    yield takeEvery(triggerAtualizaDadosBuffer, doAtualizaDadosBuffer)
}

export function* listenSendRPCCall() {
    yield takeEvery(triggerSendRPCCall, doSendRPCCall)
}